import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { last } from 'lodash-es';
import { Observable } from 'rxjs';

import {
  ActivateDeactivateCommands,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  HeatingConfigurationRegulationMode,
  HeatingConfigurationRegulationProperties,
  OperatingProgramCommandsNormal,
  OperatingProgramProperties,
  ProgramCommands,
  ProgramProperties,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';

import { HEATING_PROGRAMS, HeatingPanelService } from './heating-panel/heating-panel.service';

@Component({
  selector: 'app-temperature-schedule-manager',
  templateUrl: './temperature-schedule-manager.component.html',
  styleUrls: ['./temperature-schedule-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemperatureScheduleManagerComponent implements OnInit {
  readonly HeatingConfigurationRegulationMode = HeatingConfigurationRegulationMode;
  readonly featurePropertyKey = FeaturePropertyKey;

  shouldDispalyHeatingPanel$: Observable<boolean>;
  heatingRegulation$: Observable<Feature<HeatingConfigurationRegulationProperties, never>>;
  normal$: Observable<Feature<OperatingProgramProperties, OperatingProgramCommandsNormal>>;
  eco$: Observable<Feature<OperatingProgramProperties, ActivateDeactivateCommands>>;
  comfort$: Observable<Feature<ProgramProperties, ProgramCommands>>;

  @Input()
  circuitId: string;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private gtmService: GTMService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.shouldDispalyHeatingPanel$ = this.installationFeaturesStore.shouldDispalyHeatingPanel(
      this.circuitId
    );
    this.heatingRegulation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.configurationRegulation
    );
    this.normal$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.NORMAL)
    );
    this.eco$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.ECO)
    );
    this.comfort$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.COMFORT)
    );
  }

  onProgramTemperatureChange(value: number, feature: string): void {
    const program = last(feature.split('.'));
    this.installationFeaturesStore.updateFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, program),
      value,
      'temperature',
      'targetTemperature',
      'setTemperature'
    );

    this.gtmService.track('onSet', `Room's ${program} program temperature`, 'srcHeating');
  }
}
